import { useTheme } from '@backoffice-frontend/patterns'
import { Children, isValidElement, type ReactNode } from 'react'

type OverlayPanelProps = {
  children: ReactNode
}

export const OverlayPanel = ({ children }: OverlayPanelProps) => {
  const theme = useTheme()
  const childArray = Children.toArray(children).filter(isValidElement)

  return (
    <div
      css={theme => ({
        width: 240,
        maxHeight: '100%',
        backgroundColor: theme.semantic.ColorBackgroundDefault,
        borderRadius: 8,
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      })}
    >
      {childArray.flatMap((child, i) =>
        i > 0
          ? [
              <div
                key={`divider-${child.key}`}
                css={{
                  height: 1,
                  flexShrink: 0,
                  backgroundColor: theme.semantic.ColorAccessoryReduced,
                }}
              />,
              child,
            ]
          : [child],
      )}
    </div>
  )
}
